var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.infoObj.claimsTypeName))]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.infoObj,
      rules: _vm.dataRule,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 15
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "claimsTypeSort",
      label: _vm.$t("排序")
    }
  }, [_vm.infoObj.isEdit ? _c("a-input-number", {
    attrs: {
      id: "inputNumber",
      min: 1
    },
    model: {
      value: _vm.infoObj.claimsTypeSort,
      callback: function ($$v) {
        _vm.$set(_vm.infoObj, "claimsTypeSort", $$v);
      },
      expression: "infoObj.claimsTypeSort"
    }
  }) : _c("div", [_vm._v(_vm._s(_vm.infoObj.claimsTypeSort))])], 1), _c("a-form-model-item", {
    attrs: {
      prop: "claimsDocument",
      label: _vm.$t("索赔文件")
    }
  }, [!_vm.infoObj.isEdit ? _c("div", [_c("a-table", {
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.demageList,
      align: "center",
      pagination: false,
      rowKey: "claimsDocumentId"
    },
    scopedSlots: _vm._u([{
      key: "template",
      fn: function (text, record) {
        return [_c("a-button", {
          staticStyle: {
            padding: "0 5px"
          },
          attrs: {
            type: "link"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return _vm.previewFun(record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("模版预览")) + " ")]), _c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.templateDesc) + " ")]), _c("a-icon", {
          attrs: {
            type: "question-circle"
          }
        })], 2)];
      }
    }], null, false, 2640598340)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1) : _c("div", [_vm.mockData.length != 0 ? _c("a-transfer", {
    attrs: {
      "data-source": _vm.mockData,
      titles: [_vm.$t("所有索赔文件"), _vm.$t("已选择索赔文件")],
      "list-style": {
        width: "300px",
        height: "350px"
      },
      "target-keys": _vm.targetKeys,
      render: item => item.name,
      "show-search": true,
      "filter-option": (inputValue, item) => item.name.indexOf(inputValue) !== -1,
      "show-select-all": false
    },
    on: {
      change: _vm.handleChange
    },
    scopedSlots: _vm._u([{
      key: "children",
      fn: function ({
        props: {
          direction,
          filteredItems,
          selectedKeys,
          disabled: listDisabled
        },
        on: {
          itemSelectAll,
          itemSelect
        }
      }) {
        return [_c("a-table", {
          style: {
            pointerEvents: listDisabled ? "none" : null
          },
          attrs: {
            "row-selection": _vm.getRowSelection({
              disabled: listDisabled,
              selectedKeys,
              itemSelectAll,
              itemSelect
            }),
            pagination: false,
            columns: direction === "left" ? _vm.columns : _vm.columns1,
            "data-source": filteredItems,
            size: "small",
            scroll: {
              y: 227
            },
            "custom-row": ({
              key,
              disabled: itemDisabled
            }) => ({
              on: {
                click: () => {
                  if (itemDisabled || listDisabled) return;
                  itemSelect(key, !selectedKeys.includes(key));
                }
              }
            })
          },
          scopedSlots: _vm._u([{
            key: "template",
            fn: function (text, record) {
              return [_c("a-button", {
                staticStyle: {
                  padding: "0 5px"
                },
                attrs: {
                  type: "link"
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation();
                    return _vm.previewFun(record);
                  }
                }
              }, [_vm._v(" " + _vm._s(_vm.$t("模版预览")) + " ")]), _c("a-tooltip", [_c("template", {
                slot: "title"
              }, [_vm._v(" " + _vm._s(record.templateDesc) + " ")]), _c("a-icon", {
                attrs: {
                  type: "question-circle"
                }
              })], 2)];
            }
          }], null, true)
        }, _vm._l(direction === "left" ? _vm.columns : _vm.columns1, function (item, i) {
          return _c("span", {
            key: i,
            attrs: {
              slot: item.slots.title
            },
            slot: item.slots.title
          }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
        }), 0)];
      }
    }], null, false, 1781073910)
  }) : _vm._e(), _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.addDemageFun
    }
  }, [_vm._v(_vm._s(_vm.$t("新增索赔文件")))])], 1)]), _c("a-form-model-item", {
    attrs: {
      prop: "claimsSort",
      label: _vm.$t("理赔单参数")
    }
  }, [_vm.infoObj.isEdit ? _c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      placeholder: _vm.$t("请选择") + _vm.$t("理赔单参数")
    },
    on: {
      change: _vm.handleClaimsParamChange
    },
    model: {
      value: _vm.infoObj.claimsParam,
      callback: function ($$v) {
        _vm.$set(_vm.infoObj, "claimsParam", $$v);
      },
      expression: "infoObj.claimsParam"
    }
  }, _vm._l(_vm.claimsList, function (i) {
    return _c("a-select-option", {
      key: i.id
    }, [_vm._v(" " + _vm._s(i.name) + " ")]);
  }), 1), _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.addClassificationFun
    }
  }, [_vm._v(_vm._s(_vm.$t("新增理赔分类")))])], 1) : _vm._e(), _c("div", _vm._l(_vm.infoObj.config.claimsSort, function (item, index) {
    return _c("div", {
      key: item.sortId
    }, [_c("div", {
      staticClass: "title2"
    }, [_vm._v(" " + _vm._s(item.claimsSortName) + " "), _vm.infoObj.isEdit ? _c("a-checkbox", {
      staticStyle: {
        "margin-left": "20px",
        color: "#1890ff"
      },
      on: {
        change: function ($event) {
          return _vm.selectedAllFun(index);
        }
      },
      model: {
        value: item.selected,
        callback: function ($$v) {
          _vm.$set(item, "selected", $$v);
        },
        expression: "item.selected"
      }
    }, [_vm._v(_vm._s(_vm.$t("全选")))]) : _vm._e(), _vm.infoObj.isEdit ? _c("a-button", {
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.addParameterFun(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("新增理赔参数")))]) : _vm._e()], 1), _c("div", {
      staticClass: "listBox"
    }, [_vm._l(item.claimsParamList, function (item2, index2) {
      return !_vm.infoObj.isEdit && item2.selected || _vm.infoObj.isEdit && item2.isOpen ? _c("div", {
        key: index2
      }, [_c("a-checkbox", {
        attrs: {
          checked: item2.selected,
          disabled: _vm.infoObj.isEdit ? false : true
        },
        on: {
          click: function ($event) {
            return _vm.handleClaimsParamItemChange(index, index2);
          }
        }
      }, [_c("a-tooltip", [_c("template", {
        slot: "title"
      }, [_vm._v(" " + _vm._s(item2.name) + " ")]), _c("div", {
        staticClass: "name"
      }, [_vm._v(_vm._s(item2.name))])], 2)], 1)], 1) : _vm._e();
    }), _vm.infoObj.isEdit ? _c("div", [item.claimsParamList.length > 8 ? _c("a-button", {
      staticStyle: {
        padding: "0 5px"
      },
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.openFun(index);
        }
      }
    }, [_c("a-icon", {
      attrs: {
        type: !item.isOpen ? "down" : "up"
      }
    }), _vm._v(" " + _vm._s(!item.isOpen ? _vm.$t("展开") : _vm.$t("收起")) + " ")], 1) : _vm._e()], 1) : _vm._e()], 2)]);
  }), 0)])], 1), _c("div", {
    staticClass: "btnBox"
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_vm.isAuth("home.insuranceClaimsEdit") && _vm.infoObj.isEdit ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]) : _vm._e(), _vm._t("btn")], 2)]), _vm.classificationShow ? _c("classification-model", {
    ref: "classificationFrom",
    on: {
      cancel: function ($event) {
        _vm.classificationShow = false;
      },
      ok: _vm.classificationFun
    }
  }) : _vm._e(), _c("parameter-modal", {
    ref: "parameterRef",
    on: {
      save: _vm.parameterOk
    }
  }), _c("demage-modal", {
    ref: "demageRef",
    on: {
      save: _vm.demageOk
    }
  }), _c("preview-list-modal", {
    ref: "previewListRef",
    attrs: {
      previewVisible: _vm.previewVisible,
      fileList: _vm.fileList
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };